import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class ClubDeleted extends DomainEvent<DeletedEntity> {}
